exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.room__message-text {\n    margin-top: 20px;\n    max-width: 60%;\n    margin-left: 20%;\n}\n", ""]);

// exports
